module.exports = __webpack_public_path__ + "img/xuqiuguangchang5.9ec580f3.png";